export default __webpack_public_path__ + "static/media/question-mark.d27b277a.svg";